export default __webpack_public_path__ + "static/media/standings.3abe59e1.svg";